import moment from 'moment'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import ErrorIcon from '@mui/icons-material/Error'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import HourglassTopIcon from '@mui/icons-material/HourglassTop'
import RemoveIcon from '@mui/icons-material/Remove'
import { viz } from '../../../pages/userPages/dashboard/managerOverview/overviewTheme'

// One vocabulary for a matrix cell, shared by the grid, the legend, the
// filters and the PDF. Statuses come from the server (/training/admin/matrix);
// nothing here decides compliance. Every state has an icon and words, so
// colour is never the only signal. `pdf` is the abbreviation the PDF prints.
export const CELL_STATES = {
  compliant: { key: 'compliant', label: 'In date', short: 'In date', pdf: 'OK', Icon: CheckCircleIcon, color: viz.good },
  expiring: { key: 'expiring', label: 'Expiring soon', short: 'Expiring', pdf: 'EXP', Icon: AccessTimeIcon, color: viz.warning },
  overdue: { key: 'overdue', label: 'Overdue', short: 'Overdue', pdf: 'OVERDUE', Icon: ErrorIcon, color: viz.critical },
  notCompleted: { key: 'notCompleted', label: 'Not completed', short: 'Not done', pdf: 'NOT DONE', Icon: HighlightOffIcon, color: viz.critical },
  pending: { key: 'pending', label: 'Awaiting approval', short: 'Pending', pdf: 'PENDING', Icon: HourglassTopIcon, color: '#268EBB' },
  notRequired: { key: 'notRequired', label: 'Not required', short: '', pdf: '-', Icon: RemoveIcon, color: viz.deEmphasis },
  held: { key: 'held', label: 'Not required, but held', short: 'Held', pdf: 'HELD', Icon: CheckCircleOutlineIcon, color: viz.deEmphasis },
}

export const LEGEND_ORDER = ['compliant', 'expiring', 'overdue', 'notCompleted', 'pending', 'notRequired', 'held']

export const STATUS_FILTERS = [
  { value: 'overdue', label: 'Overdue' },
  { value: 'expiring', label: 'Expiring soon' },
  { value: 'notCompleted', label: 'Not completed' },
  { value: 'pending', label: 'Awaiting approval' },
]

export const cellState = (cell) => {
  if (!cell) return CELL_STATES.notRequired
  if (!cell.required) {
    return cell.status === 'compliant' || cell.status === 'expiring' ? CELL_STATES.held : CELL_STATES.notRequired
  }
  if (cell.pending) return CELL_STATES.pending
  return CELL_STATES[cell.status] ?? CELL_STATES.notCompleted
}

export const formatDate = (value, format = 'D MMM YYYY') => (value ? moment(value).format(format) : null)

export const pathwayTitle = (course, pathwayId) =>
  course?.pathways?.find((pathway) => pathway.id === pathwayId)?.title ?? null

export const SOURCE_LABEL = { elearning: 'E-learning', upload: 'Uploaded certificate', manual: 'Recorded by the organisation' }

// A reminder goes to people who need the course and do not hold it in date.
export const needsChasing = (cell) =>
  !!cell?.required && (cell.status === 'overdue' || cell.status === 'notCompleted')

// Totals over the required cells of the given staff.
export const summarise = (employees, courses) => {
  const totals = { required: 0, compliant: 0, expiring: 0, overdue: 0, notCompleted: 0, pending: 0 }
  employees.forEach((employee) => {
    courses.forEach((course) => {
      const cell = employee.cells?.[course._id]
      if (!cell?.required) return
      totals.required += 1
      if (totals[cell.status] !== undefined) totals[cell.status] += 1
      if (cell.pending) totals.pending += 1
    })
  })
  return {
    ...totals,
    percent: totals.required ? Math.round(((totals.compliant + totals.expiring) / totals.required) * 100) : null,
  }
}
